/**
 * Shared navigation helper for linking report rows to source documents.
 */

// Map transaction type codes to their page routes
export const TRAN_TYPE_ROUTES = {
  SI: '/sales/sale-invoice',
  NSI: '/sales/non-tax-invoice',
  SR: '/sales/sale-return',
  NSR: '/sales/non-tax-sale-return',
  SO: '/sales/sale-order',
  QT: '/sales/quotation',
  DC: '/sales/delivery-challan',
  PI: '/purchases/purchase-invoice',
  NPI: '/purchases/non-tax-invoice',
  IPI: '/purchases/import-invoice',
  PR: '/purchases/purchase-return',
  NPR: '/purchases/non-tax-purchase-return',
  PO: '/purchases/purchase-order',
  GRN: '/purchases/grn',
  CR: '/receipts/cash-receipt',
  BR: '/receipts/bank-receipt',
  CP: '/payments/cash-payment',
  BP: '/payments/bank-payment',
  JV: '/journal/general',
  CB: '/journal/cash-book',
  OB: '/master/opening-balances',
  AS: '/store/add-stock',
  RS: '/store/reduce-stock',
  ST: '/store/stock-transfer',
  SND: '/store/send-inventory',
  RCV: '/store/receive-inventory',
  REQ: '/store/purchase-requisition',
  PRO: '/store/production-order',
  MIP: '/store/material-issue',
  PRC: '/store/production-receipt',
  PS: '/pos',
  // Salary
  ADV: '/salary/advance',
  LON: '/salary/loan',
  LRC: '/salary/loan-recovery',
  PAY: '/salary/payroll-run',
  FNF: '/salary/final-settlement',
  // Fixed Assets
  DEP: '/assets/depreciation',
  FAD: '/assets/disposal',
  APR: '/assets/appreciation',
};

// Transaction type labels
export const TRAN_TYPE_LABELS = {
  PI: 'Purchase Invoice',
  NPI: 'Non-Tax Purchase Invoice',
  IPI: 'Import Purchase Invoice',
  SI: 'Sale Invoice',
  NSI: 'Non-Tax Sale Invoice',
  PR: 'Purchase Return',
  NPR: 'Non-Tax Purchase Return',
  SR: 'Sale Return',
  NSR: 'Non-Tax Sale Return',
  CR: 'Cash Receipt',
  BR: 'Bank Receipt',
  CP: 'Cash Payment',
  BP: 'Bank Payment',
  JV: 'Journal Voucher',
  CB: 'Cash Book',
  OB: 'Opening Balance',
  AS: 'Add Stock',
  RS: 'Reduce Stock',
  ST: 'Stock Transfer',
  SND: 'Send Inventory',
  RCV: 'Receive Inventory',
  MIP: 'Material Issue to Production',
  PRC: 'Production Receipt',
  GRN: 'Goods Receipt',
  PO: 'Purchase Order',
  QT: 'Quotation',
  SO: 'Sale Order',
  DC: 'Delivery Challan',
  REQ: 'Purchase Requisition',
  PRO: 'Production Order',
  PS: 'POS Sale',
  ADV: 'Salary Advance',
  LON: 'Staff Loan',
  LRC: 'Loan Recovery',
  PAY: 'Payroll Run',
  FNF: 'Final Settlement',
  DEP: 'Depreciation Run',
  FAD: 'Asset Disposal',
  APR: 'Asset Appreciation',
};

/**
 * Navigate to a transaction's source page.
 * @param {Function} navigate - react-router-dom useNavigate() instance
 * @param {string} tranTypeCode - transaction type code (e.g. 'SI', 'PI')
 * @param {string} transactionId - Firestore document ID
 */
export const navigateToTransaction = (navigate, tranTypeCode, transactionId) => {
  const route = TRAN_TYPE_ROUTES[tranTypeCode];
  if (route && transactionId) {
    navigate(route, { state: { viewTransactionId: transactionId } });
  }
};

